import {Component, Input} from '@angular/core';
import {Router} from 'src/app/infrastructure/router/router';
import {BaseMenuItemComponent} from 'src/app/ui/webapp/component/menu/base-menu-item.component';

type Margin = 'ml-4' | 'ml-2';

@Component({
  selector: 'app-menu-item',
  templateUrl: 'menu-item.component.html'
})
export class MenuItemComponent extends BaseMenuItemComponent {
  @Input() margin: Margin = 'ml-4';

  constructor(router: Router) {
    super(router);
  }
}
